import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Image from 'react-cool-img';
import CartIcon from '@mui/icons-material/AddShoppingCartSharp';
import { IProduct } from '../types/Product';
import gqlUrl from '../constants/gqlUrl';
import { FC, useContext } from 'react';
import CartContext from '../contexts/CartContext';
import placeholderImg from '../assets/placeholder-image.png'

const ProductCard: FC<{ product: IProduct }> = ({ product }) => {
  const { addToCart } = useContext(CartContext);
  const imgUrl = `${gqlUrl}${product.imgUrl}`;

  return (
    <>
      <Card variant="outlined">
        <Image
          src={imgUrl}
          alt={product.title}
          height="500px"
          style={{
            maxWidth: '500px',
            maxHeight: '500px',
            height: '500px',
            width: '100%',
            objectFit: 'cover',
          }}
          placeholder={placeholderImg}
        />
        <CardContent>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <Box>
              <Typography variant="body1" sx={{ lineHeight: 1 }}>
                {product.title}
              </Typography>
              <Typography variant="caption" sx={{ fontSize: '1.3em' }}>
                {product?.formattedPrice}
              </Typography>
            </Box>
            <IconButton
              aria-label="add to cart"
              onClick={() => addToCart(product)}
            >
              <CartIcon />
            </IconButton>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
};

export default ProductCard;
